import { ValueOf } from './util';

export const outputPatterns = {
  PREPAID_TOTAL: 'プリペイド全体',
  CHARGE: 'チャージ内訳',
  SETTLEMENT: '決済内訳（決済手段）',
  SETTLEMENT_BY_CODE: '決済内訳（コード区分）',
  CAMPAIGN: 'キャンペーン',
  CAMPAIGN_BREAKDOWN: 'キャンペーン内訳',
  BULK_GRANT: '一括付与',
  UNUSED_BALANCE: '基準日未使用残高',
} as const;

export type OutputPatternKey = keyof typeof outputPatterns;
export type OutputPatternValue = ValueOf<typeof outputPatterns>;

export const outputPatternKeys = Object.keys(outputPatterns) as (OutputPatternKey[]);

/** v-select用items */
export const outputPatternItems = outputPatternKeys
  .map((key) => ({
    title: outputPatterns[key],
    value: key,
  }));
